import React from "react";
import DetailOutreachPage from "../../components/Pages/Outreach/Details/Details";

const DetailOutreach = () => {
  return (
    <div>
      <DetailOutreachPage />
    </div>
  );
};

export default DetailOutreach;
